import {getCookieConsentValue} from "react-cookie-consent";

const KEY = 'sedee-token';

export const getToken = () => getCookieConsentValue() ? (localStorage.getItem(KEY) || '') : '';
export const removeToken = () => getCookieConsentValue() ? localStorage.removeItem(KEY) : '';
export const setToken = (token: string) => getCookieConsentValue() ? localStorage.setItem(KEY, token) : '';
